import moment from 'moment';
import { ComDinheiroAPI } from '../API/comdinheiro-api';
import {
    getDayMonthYearByPtDate,
    getDayMonthYearByStringDate,
    getDayMonthsAgo,
    getFirstBeforeBusinessDay,
    getFirstDayMonth, getLastDayMonth,
    getMonthAndYearBefore,
    getTitleCod,
    isMonthAbleToQuotas,
    justNumbers,
    toJsonQuotasAssets
} from '../components/utils/utils';

import _ from 'lodash';
import { LocalBenchMarksAPI } from '../API/local_benchmaks';
import allActions from "../actions";
import { doGetCDIMonth, doSaveCDIMonth } from './CdiLocalController';
import { doGetLocalInfosByFundIdMonthYear, doSaveOrUpdateLocalQuotas, getClientJsonQuotas, getLocalInfosByListFunds, getLocalQuotasByListFunds, trySaveListLocalInfosByFundId, trySaveListLocalQuotas } from './FundLocalQuotasController';
import { doGetIGPMMonth, doSaveIGPMMonth } from './IgpmLocalController';
import { doGetIpcaDpMonthAndAgoMonth, doSaveIpcaDpMonth } from './IpcaDpController';
import { needQuotasTitle } from './TitleController';
import { trySaveTitlesListLocalQuotas } from './TitleLocalQuotasController';
import { RankingFundsManagersAPI } from '../API/ranking_funds_managers';
import { RankingFundsAdminsAPI } from '../API/ranking_funds_admins';
import { IbovCdiAPI } from '../API/ibov_cdi';
import { REQ_COMDINHEIRO_TYPE } from '../API/reqs_comdinheiro';
import { FundAPI } from '../API/fund';
import { FundLocalQuotasAPI } from '../API/fund_local_quotas';

export async function getBladeComdinheiroByDate(referenceDate, fund, dispatch) {

    console.log("FUND: ", fund);

    const cnpj = fund.cnpj

    console.log("COMDINHEIRO");
    console.log("referenceDate: ", referenceDate);
    console.log("cnpjs: ", cnpj);

    referenceDate = getFirstBeforeBusinessDay(referenceDate);

    console.log("referenceDate business: ", referenceDate);

    let allResponse = {
        comdinheiro: {}
    };

    dispatch(allActions.innerLoadActions.setInnerLoad({
        show: true,
        // extraMargin: true,
        loadMessage: 'Carregando Características do Fundo...',
    }));

    let responseInfosFund = null;

    //Verificar se essa informação já existe na base de dados local
    const { month: mInfo, year: yInfo } = getDayMonthYearByPtDate(referenceDate);

    const responseInfosLocal = await doGetLocalInfosByFundIdMonthYear(parseInt(fund.fundId), mInfo, yInfo);
    if (responseInfosLocal.success && responseInfosLocal.body[0] && responseInfosLocal.body[0].json_fund_infos) {
        const { json_fund_infos } = responseInfosLocal.body[0];
        responseInfosFund = JSON.parse(json_fund_infos);

    } else {
        //fund_id, fd.cnpj, fd.suffix, fd.ticker, fd.subclass, fd.validity_subclass
        const preResponseInfosFund = await ComDinheiroAPI.getInfosFundComdinheiroByDate(referenceDate, fund, mInfo, yInfo);
        responseInfosFund = preResponseInfosFund.body[cnpj];
        await FundLocalQuotasAPI.updateInfosLocalQuotasByFundId(parseInt(fund.fundId), JSON.stringify(preResponseInfosFund.body[cnpj]), mInfo, yInfo);
    }


    let fundBenchmark = null;
    let fundBenchmarkName = null;

    if (fund.benchmark_comdinheiro && fund.benchmark) {
        fundBenchmark = fund.benchmark_comdinheiro;
        fundBenchmarkName = fund.benchmark;
    } else if (fund.local_benchmark_id) {
        const localBenchmark = await LocalBenchMarksAPI.getLocalBenchmarkById(fund.local_benchmark_id);
        if (localBenchmark?.success && localBenchmark.body.rows[0]) {
            fundBenchmark = localBenchmark.body.rows[0].comdinheiro_name;
            fundBenchmarkName = localBenchmark.body.rows[0].name;
        }
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //Verificar restante das informações localmente, para evitar requisições desnecessárias à API da comdinheiro
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    dispatch(allActions.innerLoadActions.setInnerLoad({
        show: true,
        // extraMargin: true,
        loadMessage: 'Verificando informações locais...',
    }));

    const bladefundLocalData = await FundAPI.getBladeFundLocalDataByFundIdAndMonthAndYear(parseInt(fund.fundId), mInfo, yInfo);
    if (bladefundLocalData.body?.length === 1) {
        //Informaçoes encontradas localmente early return
        const allResponseLocal = bladefundLocalData.body[0].local_data;
        if (allResponseLocal) {

            const allResponse = {
                comdinheiro: {
                    dadosCadastrais: responseInfosFund.dados_cadastrais,
                    realBenchmark: fundBenchmarkName,
                    ...JSON.parse(allResponseLocal),
                }
            }
            return {
                success: true,
                body: allResponse,
            }
        }
    }

    ////////////////////////////////////
    //Fim verificação local de informações
    ////////////////////////////////////

    dispatch(allActions.innerLoadActions.setInnerLoad({
        show: true,
        // extraMargin: true,
        loadMessage: 'Carregando Retornos do Fundo...',
    }));

    console.log("FUND TO BLADE: ", fund);

    const responseInfosReturnTableFund = await ComDinheiroAPI.getInfosReturnTableComdinheiroByDate(referenceDate, cnpj, fundBenchmark);
    //Obtendo data de 36 meses atrás
    let initDate = getDayMonthsAgo(referenceDate, 37);
    dispatch(allActions.innerLoadActions.setInnerLoad({
        show: true,
        // extraMargin: true,
        loadMessage: 'Carregando Patrimônios do Fundo...',
    }));
    const responsePatrimonioFund = await ComDinheiroAPI.getTablePatrimonioComdinheiroByPeriod(initDate, referenceDate, cnpj, REQ_COMDINHEIRO_TYPE.LAMINA);

    dispatch(allActions.innerLoadActions.setInnerLoad({
        show: true,
        // extraMargin: true,
        loadMessage: 'Carregando Riscos e Retornos do Fundo...',
    }));
    // Usando fundBenchmark para consistência (mesmo benchmark usado na tabela de retornos)
    const responseRiscoRetornoFund = await ComDinheiroAPI.getTableRiscoRetornoComdinheiroByDate(referenceDate, cnpj, fundBenchmark);

    const allResponseBlade = [
        responseInfosReturnTableFund.success ? responseInfosReturnTableFund.body : false,
        responsePatrimonioFund.success ? responsePatrimonioFund.body : false,
        responseRiscoRetornoFund.success ? responseRiscoRetornoFund.body : false,
    ]

    console.log("ALL RESPONSE BLADE: ", allResponseBlade);

    if (allResponseBlade && !allResponseBlade.includes(false)) {

        const responseSaveBladeLocalData = await FundAPI.createOrUpdateBladeFundLocalDataByFundIdMonthYear(parseInt(fund.fundId), mInfo, yInfo, JSON.stringify({
            returnTable: allResponseBlade[0],
            patrimonio36: allResponseBlade[1],
            riscoRetorno: allResponseBlade[2],
        }));

        allResponse.comdinheiro.dadosCadastrais = responseInfosFund.dados_cadastrais;
        allResponse.comdinheiro.returnTable = allResponseBlade[0];
        allResponse.comdinheiro.patrimonio36 = allResponseBlade[1];
        allResponse.comdinheiro.riscoRetorno = allResponseBlade[2];
        allResponse.comdinheiro.realBenchmark = fundBenchmarkName;

        return {
            success: true,
            body: allResponse,
        }

    } else {

        return {
            success: false,
        }

    }


}

export async function getFundCompare(cnpjs, benchmarks, startDate, endDate) {

    const responsePatrimony = await ComDinheiroAPI.getTablePatrimonioComdinheiroByPeriod(startDate, endDate, cnpjs);
    console.log('responsePatrimony: ', responsePatrimony);

}


/**
 * Retorna o próximo mês a ser lançado do cliente
 * @param {Array} realAssets ativos a serem requisitados (cnpjs)
 * @param {String} startDate primeiro dia a ser obtido cota
 * @param {String} endDate último dia a ser obtida a cota
 * @param {Boolean} doQuotas indica se é necessário ou não o processamento de obteção de cotas da API
 * @returns {Object} 
 * 
 * O método deve verificar quais informações já existem na base local, pelo atributo fund_local_quota_id
 * Caso haja valor é devido já haver informação salva localmente
 * Após obtenção das novas informações o método deve salvar as novas informações obtidas localmente
 **/
export async function getCotasAndSaveByListAssets(realAssets, startDate, endDate, doQuotas) {

    //Cotas a serem retornadas
    let cotas = {};
    let cotasBefore = {};

    //Cnpjs dos fundos que ainda não possuem cotas na base local    
    let dataToGetApi = [];
    let dataBeforeToGetApi = [];
    let dataToGetLocal = [];
    //Infos de admnistração do fundo
    let infosToGetApi = [];
    let infosToGetLocal = [];

    const realMonth = parseInt(startDate.substring(3, 5));
    const realYear = parseInt(startDate.substring(6, 10));

    //console.log("ASSETS GET COTAS: ", _.cloneDeep(realAssets));

    realAssets.forEach(asset => {

        if (!asset.fund_local_quota_id) {

            dataToGetApi.push({
                cnpj: asset.cnpj + (asset.suffix ? '_' + asset.suffix : ''), //adicionando lógica para caso de fundo com SUFIXO
                fund_id: asset.fund_id
            });

            //Caso existe o fund_local_quota_id os dados são obtidos da base própria
        } else if (asset.fund_local_quota_id) {

            dataToGetLocal.push({
                fund_id: asset.fund_id,
                fund_local_quota_id: asset.fund_local_quota_id
            });

            infosToGetLocal.push({
                fund_id: asset.fund_id,
                fund_local_quota_id: asset.fund_local_quota_id
            })

        }

        //Garantindo que quotas_anbima_before seja um array, pois poderia ser "[]"
        if (asset.quotas_anbima_before && !Array.isArray(asset.quotas_anbima_before)) {
            //NEW VALUE QUOTA
            //asset.quotas_anbima_before = JSON.parse(asset.quotas_anbima_before);            
            asset.quotas_anbima_before = getClientJsonQuotas(JSON.parse(asset.quotas_anbima_before), asset.client_id);
        }

        //if (!asset.quotas_anbima_before || asset.quotas_anbima_before.length === 0) {
        if (!asset.quotas_anbima_before) {

            ////Removendo fundos especiais da requisição pois não possuem cotas
            if (asset.quotas_anbima_before && asset.quotas_anbima_before.length === 0 && asset.special) {
                //Não realiza
            } else {
                dataBeforeToGetApi.push({
                    cnpj: asset.cnpj + (asset.suffix ? '_' + asset.suffix : ''), //adicionando lógica para caso de fundo com SUFIXO
                    fund_id: asset.fund_id
                });
            }

            //}

            //Caso existe o fund_local_quota_id os dados são obtidos da base própria
        }


    });

    const today = new Date();
    const isCurrentMonth = realMonth === (today.getMonth() + 1) && realYear === today.getFullYear();

    //Atribuindo vetor vazio para cotas de fundos speciais
    realAssets.filter(el => el.special).forEach(asset => {

        if (!asset.quotas_anbima) {
            asset.quotas_anbima = [];
        }

    });

    //No caso da tela de CARTEIRA onde não são necessários os valores de quota é nesse método que obtemos informações relevantes 
    //Ex: Disponibilidade (D + 0)

    //Obtendo Infos localmente
    //if (dataToGetLocal.length > 0) {
    if (infosToGetLocal.length > 0) {

        let localFundQuotasIds = [];
        infosToGetLocal.forEach(element => {
            localFundQuotasIds.push(element.fund_local_quota_id);
        });

        realAssets = await getLocalInfosByListFunds(realAssets, localFundQuotasIds);

    }

    if (dataToGetLocal.length > 0) {
        //no processmento o objeto filteredQuotas já é atualizado automaticamente       
        await getLocalQuotasByListFunds(cotas, dataToGetLocal, startDate, "fund_id",
            realAssets[0] ? realAssets[0].client_id : null);
    }

    //Obtendo cotas JSON
    toJsonQuotasAssets(realAssets);

    return {
        toReturnAssets: realAssets,
        cotas: cotas,
    }

}

//Obtenção das [Cotas diárias] do FUNDO
export async function getCotasByListCnpjs(cnpjsAndFundIds, startDate, endDate, noRepeatLastQuotaWhenNoQuota) {

    let response = await ComDinheiroAPI.getCotasDiariasPorPeríodo(cnpjsAndFundIds, startDate, endDate, noRepeatLastQuotaWhenNoQuota);

    if (response.success) {

        return {
            success: true,
            cotas: response.body
        }

    } else {

        return {
            success: false
        }

    }

}


//Obtenção dos [Dados Cadastrais] do FUNDO
export async function getInfosByListCnpjs(cnpjsAndFundIds, referenceDate) {

    console.log(cnpjsAndFundIds);
    console.log(referenceDate);
    let response = await ComDinheiroAPI.getInfosFundComdinheiroByDate(referenceDate, cnpjsAndFundIds);

    if (response.success) {

        return {
            success: true,
            infos: response.body
        }

    } else {

        return {
            success: false
        }

    }

}

//Tamanho do lote de fundos por requisição nas atualizações em massa.
//Dados cadastrais: 100, o mesmo valor já validado em produção por
//fund.controller.updateAllFundInfosComdinheiro.
//Cotas: também 100, mas sem validação equivalente — o HistoricoCotacao002 pede
//`cod` + `cod.patrimonio` por fundo (normalizeCnpjsToUrlCotas), então um lote cheio manda
//200 colunas num único `x=`. Se a Comdinheiro recusar lotes desse tamanho, basta reduzir
//esta constante: nada mais no fluxo depende do valor.
const BULK_QUOTAS_CHUNK_SIZE = 100;
const BULK_INFOS_CHUNK_SIZE = 100;

/**
 * Chave pela qual a resposta de cotas será indexada.
 *
 * formatResponseListCotas monta o mapa de retorno usando o valor de `cnpj` exatamente como
 * foi enviado e, para fundo com ticker, só acha o valor lendo `dayCotas[chave.toLowerCase()]`.
 * Enviando o CNPJ num fundo com ticker nenhuma das chaves casa e parseFloatComdinheiro(undefined)
 * devolve 0 — gravaria uma série inteira de zeros. Por isso a chave é o próprio ticker.
 */
function buildQuotaRequestKey(fund) {

    return fund.ticker ? fund.ticker : fund.cnpj;
}

/**
 * Quebra a lista em lotes de no máximo `size` garantindo que uma mesma chave de resposta
 * nunca caia duas vezes no mesmo lote — os mapas de retorno da Comdinheiro são indexados por
 * essa chave, então dois fundos de subclasses diferentes do mesmo CNPJ (ou dois fundos
 * `special`, que podem repetir CNPJ) se sobrescreveriam dentro do mesmo lote.
 */
function buildChunksWithUniqueKey(list, size, getKey) {

    const chunks = [];

    list.forEach(item => {

        const key = getKey(item);

        let target = chunks.find(chunk => chunk.length < size
            && !chunk.some(el => getKey(el) === key));

        if (!target) {
            target = [];
            chunks.push(target);
        }

        target.push(item);
    });

    return chunks;
}

function buildBulkFailure(fund, reason) {

    return {
        fund_id: fund.fund_id,
        fund_name: fund.fund_name,
        cnpj: fund.cnpj,
        reason: reason,
    };
}

/**
 * Motivo exibido quando a Comdinheiro rejeita a consulta do lote inteiro.
 *
 * Como não há mais refazimento item a item, todos os fundos do lote falham juntos: a mensagem
 * precisa dizer isso, senão parece que cada CNPJ tem um problema próprio.
 */
function buildBatchFailureReason(stage, chunkLength, unitLabel) {

    return 'falha na requisição de ' + stage + ' à Comdinheiro'
        + (chunkLength > 1 ?
            ' (lote de ' + chunkLength + ' ' + unitLabel + ' rejeitado por inteiro)' : '');
}

function notifyBulkProgress(onProgress, stage, current, total, label) {

    if (onProgress) {
        onProgress({ stage: stage, current: current, total: total, label: label });
    }
}

/**
 * Série de cotas utilizável.
 *
 * Duas situações fazem a Comdinheiro devolver algo que parece sucesso mas não é: quando todos
 * os dias vêm "nd" a série sai vazia, e quando a coluna do fundo não existe na resposta cada
 * dia entra com valor_cota 0 (parseFloatComdinheiro(undefined) === 0). Gravar qualquer um dos
 * dois é pior que falhar: cria a linha em fund_local_quotas e transforma "sem cotas" em
 * "cotas zeradas".
 */
function isValidQuotasSerie(serie) {

    return Array.isArray(serie)
        && serie.length > 0
        && serie.some(quota => quota
            && Number.isFinite(quota.valor_cota)
            && quota.valor_cota > 0);
}

/**
 * Não existe UNIQUE em fund_local_quotas(fund_id, month, year) — só um índice não-único — e a
 * tabela já tem registro duplicado. Como o UPDATE casa por fund_id/month/year, um rowCount maior
 * que 1 significa que a gravação atingiu mais de uma linha. Não é erro, mas precisa aparecer em
 * vez de passar em silêncio.
 *
 * @returns {Object|null} entrada de aviso para a lista de falhas, ou null quando está tudo normal
 */
function buildDuplicatedRowWarning(fund, responseBody, label) {

    const rowCount = responseBody ? responseBody.rowCount : null;

    if (typeof rowCount !== 'number' || rowCount <= 1) {
        return null;
    }

    return buildBulkFailure(fund,
        'atenção: ' + rowCount + ' linhas de ' + label
        + ' atualizadas — registro duplicado em fund_local_quotas para esse fundo/mês');
}

/**
 * Mensagem de falha de gravação de cotas. O servidor pode recusar por dois motivos distintos:
 * 400 quando já existem carteiras conciliadas e lançadas com essas cotas (traz a lista de
 * clientes) e 409 quando `only_if_empty` impediu a sobrescrita de cotas já gravadas.
 */
function buildSaveQuotasFailureReason(responseBody) {

    if (!responseBody || !responseBody.message) {
        return 'falha ao salvar as cotas localmente';
    }

    const clients = responseBody.clients;
    if (!clients || !clients.length) {
        return responseBody.message;
    }

    const names = [];
    clients.forEach(client => {
        if (client.label_name && !names.includes(client.label_name)) {
            names.push(client.label_name);
        }
    });

    if (!names.length) {
        return responseBody.message;
    }

    return responseBody.message + ' ('
        + names.slice(0, 3).join(', ')
        + (names.length > 3 ? ' e outros' : '') + ')';
}

/**
 * Atualização em massa das COTAS mensais de uma lista de fundos, em lotes de CNPJs.
 *
 * Mesmo caminho do "Atualizar cotas" do cadastro de fundo (NewFund.fetchAndSaveQuotasForMonth),
 * porém com vários fundos por requisição. A persistência é feita por doSaveOrUpdateLocalQuotas,
 * que faz INSERT quando ainda não existe linha em fund_local_quotas e UPDATE quando existe.
 *
 * @param {Array<Object>} funds fundos com { fund_id, fund_name, cnpj, suffix, subclass, validity_subclass, ticker }
 * @param {Number} month
 * @param {Number} year
 * @param {Function} onProgress callback ({ stage, current, total, label })
 * @returns {Object} { updated: [fund_id], failures: [{ fund_id, fund_name, cnpj, reason }] }
 */
export async function doBulkUpdateQuotasByListFunds(funds, month, year, onProgress) {

    const updated = [];
    const failures = [];

    const list = (funds || []).filter(fund => fund.cnpj || fund.ticker);

    (funds || []).filter(fund => !fund.cnpj && !fund.ticker).forEach(fund => {
        failures.push(buildBulkFailure(fund, 'fundo sem CNPJ e sem ticker cadastrados'));
    });

    if (!list.length) {
        return { updated, failures };
    }

    const startDate = moment(new Date(year, parseInt(month) - 1, 1)).format('DD/MM/YYYY');
    const endDate = moment(new Date(year, parseInt(month), 0)).format('DD/MM/YYYY');

    const chunks = buildChunksWithUniqueKey(list, BULK_QUOTAS_CHUNK_SIZE, buildQuotaRequestKey);

    let processed = 0;

    for (let c = 0; c < chunks.length; c++) {

        const chunk = chunks[c];

        //normalizeCnpjsToUrlCotas já resolve ticker, sufixo e subclasse por vigência através
        //de getCodeToComdinheiroQuotas; a chave de resposta é o campo `cnpj` que enviamos
        const requestItems = chunk.map(fund => ({ ...fund, cnpj: buildQuotaRequestKey(fund) }));

        const responseQuotas = await ComDinheiroAPI.getCotasDiariasPorPeríodo(requestItems, startDate, endDate);

        //Uma requisição por lote, sem refazer item a item. Um único código inválido faz a
        //Comdinheiro rejeitar a consulta inteira; nesse caso todos os fundos do lote são
        //reportados como falha em tela, em vez de gerarem uma nova rodada de requisições.
        for (let i = 0; i < chunk.length; i++) {

            const fund = chunk[i];
            const requestKey = requestItems[i].cnpj;

            processed++;
            notifyBulkProgress(onProgress, 'cotas', processed, list.length, fund.fund_name);

            if (!responseQuotas.success) {
                failures.push(buildBulkFailure(fund,
                    buildBatchFailureReason('cotas', chunk.length, 'fundos')));
                continue;
            }

            const infos = responseQuotas.body ? responseQuotas.body[requestKey] : null;
            const serie = infos ? infos.serie_historica : null;

            if (!isValidQuotasSerie(serie)) {
                failures.push(buildBulkFailure(fund,
                    'a Comdinheiro não retornou cotas válidas para o código ' + requestKey));
                continue;
            }

            //onlyIfEmpty = true: a atualização em massa NUNCA sobrescreve cotas já gravadas.
            //A condição é aplicada no WHERE do UPDATE pelo servidor, então a garantia não depende
            //de a seleção acima estar correta.
            const responseSave = await doSaveOrUpdateLocalQuotas(fund.fund_id,
                serie,
                startDate,
                month,
                year,
                undefined,
                true);

            if (responseSave.success) {

                updated.push(fund.fund_id);

                const duplicated = buildDuplicatedRowWarning(fund, responseSave.body, 'cotas');
                if (duplicated) failures.push(duplicated);

            } else {

                failures.push(buildBulkFailure(fund, buildSaveQuotasFailureReason(responseSave.body)));
            }
        }
    }

    return { updated, failures };
}

/**
 * Atualização em massa dos DADOS CADASTRAIS (json_fund_infos) de uma lista de fundos.
 *
 * Dados cadastrais são atributo do CNPJ, não da subclasse: o ComparaFundos001 é consultado uma
 * vez por CNPJ (sem ticker/sufixo/subclasse, como faz o job do server) e o resultado é aplicado
 * a todos os fundos que compartilham aquele CNPJ.
 *
 * updateInfosLocalQuotasByFundId é um UPDATE puro: sem linha em fund_local_quotas para o
 * mês/ano, a gravação é um no-op silencioso. Por isso os fundos que ainda não possuem linha
 * passam antes pela obtenção de cotas, que é quem faz o INSERT.
 *
 * @param {Array<Object>} funds fundos com { fund_id, fund_name, cnpj, fund_local_quota_id, ... }
 * @param {Number} month
 * @param {Number} year
 * @param {Function} onProgress callback ({ stage, current, total, label })
 * @returns {Object} { updated: [fund_id], failures: [{ fund_id, fund_name, cnpj, reason }] }
 */
export async function doBulkUpdateInfosByListFunds(funds, month, year, onProgress) {

    const updated = [];
    const failures = [];

    const list = funds || [];
    if (!list.length) {
        return { updated, failures };
    }

    //Garantindo a existência da linha em fund_local_quotas para quem ainda não tem
    const withoutRow = list.filter(fund => !fund.fund_local_quota_id);
    const ensuredFundIds = new Set();
    const quotasFailureReasons = {};

    if (withoutRow.length) {

        const responseQuotas = await doBulkUpdateQuotasByListFunds(withoutRow, month, year, onProgress);

        responseQuotas.updated.forEach(fundId => ensuredFundIds.add(fundId));
        responseQuotas.failures.forEach(failure => {
            quotasFailureReasons[failure.fund_id] = failure.reason;
        });
    }

    const eligible = [];
    list.forEach(fund => {

        if (!fund.cnpj) {

            failures.push(buildBulkFailure(fund, 'fundo sem CNPJ cadastrado'));

        } else if (fund.fund_local_quota_id || ensuredFundIds.has(fund.fund_id)) {

            eligible.push(fund);

        } else {

            failures.push(buildBulkFailure(fund,
                'sem registro de cotas no mês — atualize as cotas primeiro'
                + (quotasFailureReasons[fund.fund_id] ? ' (' + quotasFailureReasons[fund.fund_id] + ')' : '')));
        }
    });

    if (!eligible.length) {
        return { updated, failures };
    }

    const referenceDate = getFirstBeforeBusinessDay(moment.utc(getLastDayMonth(month, year)).format('DD/MM/YYYY'));

    //Um pedido por CNPJ, aplicado depois a todos os fundos daquele CNPJ
    const fundsByCnpjDigits = {};
    eligible.forEach(fund => {

        const digits = justNumbers(fund.cnpj);
        if (!fundsByCnpjDigits[digits]) {
            fundsByCnpjDigits[digits] = [];
        }
        fundsByCnpjDigits[digits].push(fund);
    });

    //Sem ticker/sufixo/subclasse: getCodeToComdinheiroQuotas devolve só os dígitos do CNPJ,
    //que é o formato que o ComparaFundos001 espera (mesmo do job do server)
    const requestItems = Object.keys(fundsByCnpjDigits).map(digits => ({ cnpj: digits }));

    const chunks = buildChunksWithUniqueKey(requestItems, BULK_INFOS_CHUNK_SIZE, item => item.cnpj);

    let processed = 0;

    for (let c = 0; c < chunks.length; c++) {

        const chunk = chunks[c];

        const responseInfos = await ComDinheiroAPI.getInfosFundComdinheiroByDate(referenceDate, chunk);

        //Mesma regra das cotas: uma requisição por lote, sem refazer CNPJ a CNPJ quando a
        //Comdinheiro rejeita a consulta inteira
        for (let i = 0; i < chunk.length; i++) {

            const digits = chunk[i].cnpj;
            const chunkFunds = fundsByCnpjDigits[digits];

            //A resposta é chaveada pelo CNPJ que a própria Comdinheiro devolve (indicador
            //"cnpj do fundo"), que pode vir com máscara diferente da que está no cadastro
            let row = null;
            if (responseInfos.success && responseInfos.body) {
                Object.entries(responseInfos.body).forEach(([cnpjKey, value]) => {
                    if (justNumbers(cnpjKey) === digits) {
                        row = value;
                    }
                });
            }

            for (let f = 0; f < chunkFunds.length; f++) {

                const fund = chunkFunds[f];

                processed++;
                notifyBulkProgress(onProgress, 'dados cadastrais', processed, eligible.length, fund.fund_name);

                if (!responseInfos.success) {
                    failures.push(buildBulkFailure(fund,
                        buildBatchFailureReason('dados cadastrais', chunk.length, 'CNPJs')));
                    continue;
                }

                if (!row || !row.dados_cadastrais) {
                    failures.push(buildBulkFailure(fund, 'a Comdinheiro não retornou dados cadastrais para o CNPJ'));
                    continue;
                }

                //onlyIfEmpty = true: nunca sobrescreve dados cadastrais já gravados (409 do server)
                const responseSave = await FundLocalQuotasAPI.updateInfosLocalQuotasByFundId(fund.fund_id,
                    JSON.stringify(row),
                    month,
                    year,
                    true);

                if (responseSave.success) {

                    updated.push(fund.fund_id);

                    const duplicated = buildDuplicatedRowWarning(fund, responseSave.body, 'dados cadastrais');
                    if (duplicated) failures.push(duplicated);

                } else {

                    failures.push(buildBulkFailure(fund,
                        responseSave.body && responseSave.body.message ?
                            responseSave.body.message : 'falha ao salvar os dados cadastrais localmente'));
                }
            }
        }
    }

    return { updated, failures };
}

async function doGetTitleInfos(noQuotasTitles, startDate, endDate, preLoadIpcaDp, isBefore) {

    const responseInfosTitle = await ComDinheiroAPI.getTitlesInfos(noQuotasTitles, startDate, endDate);
    if (responseInfosTitle.success && responseInfosTitle.body) {

        const { mapTitleCotas, ipcaDp } = responseInfosTitle.body;
        console.log('RESPONSE TITLES FORMATTED: ', responseInfosTitle.body);

        //montando objeto para ser salvo localmente 
        const toSave = [];
        const mapTitleIdSerie = {};
        Object.entries(mapTitleCotas).map(([key, row]) => {

            const titleId = noQuotasTitles.find(el => getTitleCod(el, true) === key).title_id;
            toSave.push({
                title_id: titleId,
                cotas: row,
            });

            mapTitleIdSerie[titleId] = row;
        })

        console.log('toSave: ', toSave);

        //Salvar informações localmente
        trySaveTitlesListLocalQuotas(toSave, startDate);

        if (!preLoadIpcaDp) { //não houve retorno de ipca dp

            doSaveIpcaDpMonth(ipcaDp, startDate);

        }

        //povoando title_local_quotas
        noQuotasTitles.forEach(element => {
            element[isBefore ? 'title_local_quotas_before' : 'title_local_quotas'] = mapTitleIdSerie[element.title_id];
            element[isBefore ? 'ipcadp_local_before' : 'ipcadp_local'] = preLoadIpcaDp ? JSON.parse(preLoadIpcaDp.json_ipcadp) : ipcaDp;
        });
    }

    return noQuotasTitles;
}

//Obtenção de informações do título na comdinheiro
export async function getInfosTitlesAndSaveByListCodTitles(titleAssets, startDate, endDate) {

    const { month, year } = getDayMonthYearByStringDate(startDate);

    if (isMonthAbleToQuotas(month, year)) {

        if (titleAssets && titleAssets.length > 0) {

            //Verificando se já existe a lista de ipcadp_local
            //const ipcaDpLocal = await doGetIpcaDpMonth(startDate);
            const { ipcaDpActualMonth, ipcaDpAgoMonth } = await doGetIpcaDpMonthAndAgoMonth(startDate);
            console.log('ipcaDpActualMonth: ', ipcaDpActualMonth);
            console.log('ipcaDpAgoMonth: ', ipcaDpAgoMonth);

            const noQuotasTitles = [];
            const noQuotasTitlesBefore = [];
            //Verificar se existem informações locais dos títulos
            titleAssets.forEach(titleAssetLoop => {

                //Retirando requisições desnecessáruas para o caso de titulos que não possuem essas informações na comdinheiro
                if (needQuotasTitle(titleAssetLoop)) {
                    //Verificando cotas atuais
                    if (!titleAssetLoop.title_local_quotas) {

                        noQuotasTitles.push(titleAssetLoop);

                    } else {

                        titleAssetLoop.title_local_quotas = JSON.parse(titleAssetLoop.title_local_quotas);
                        if (ipcaDpActualMonth) {
                            titleAssetLoop.ipcadp_local = JSON.parse(ipcaDpActualMonth.json_ipcadp);
                        }

                    }

                    //Verificando cotas anteriores
                    if (!titleAssetLoop.title_local_quotas_before) {

                        noQuotasTitlesBefore.push(titleAssetLoop);

                    } else {

                        titleAssetLoop.title_local_quotas_before = JSON.parse(titleAssetLoop.title_local_quotas_before);
                        if (ipcaDpAgoMonth) {
                            titleAssetLoop.ipcadp_local_before = JSON.parse(ipcaDpAgoMonth.json_ipcadp);
                        }

                    }
                }

            });

            //Caso não haja, fazer requisição a API
            if (noQuotasTitles.length > 0) {

                await doGetTitleInfos(noQuotasTitles, startDate, endDate, ipcaDpActualMonth);

            }

            //Caso não haja, fazer requisição a API
            if (noQuotasTitlesBefore.length > 0) {

                const { monthBefore, yearBefore } = getMonthAndYearBefore(startDate);
                const startDateBefore = getFirstDayMonth(monthBefore, yearBefore);
                const endDateBefore = moment.utc(getLastDayMonth(monthBefore, yearBefore)).format('DD/MM/YYYY');

                await doGetTitleInfos(noQuotasTitlesBefore, startDateBefore, endDateBefore, ipcaDpAgoMonth, true);

            }


            return titleAssets;

        } else {

            return false;

        }
    }



}

//Obtendo Informações de CDI
export async function getCDIAndSave(startDate, endDate) {

    console.log("INDO BUSCAR CDI");

    const { month, year } = getDayMonthYearByStringDate(startDate);

    console.log('MONTH: ', month);
    console.log('YEAR: ', year);
    console.log('isMonthAbleToQuotas(month, year): ', isMonthAbleToQuotas(month, year))
    if (isMonthAbleToQuotas(month, year)) {
        //verificando se existe CDI local
        const cdiLocal = await doGetCDIMonth(month, year);
        if (cdiLocal.success) {

            return cdiLocal.body;

        } else {

            const responseCDI = await ComDinheiroAPI.getCDI(startDate, endDate);
            if (responseCDI.success) {

                doSaveCDIMonth(responseCDI.body, startDate);
                return responseCDI.body;

            } else {

                console.error("FALHA AO BUSCAR CDI NA API");

            }

        }

    } else {
        return [];
    }

}

//Obtendo Informações de IGPMN
export async function getIGPMAndSave(startDate, endDate) {

    console.log("INDO BUSCAR IGPM");

    const { month, year } = getDayMonthYearByStringDate(startDate);

    console.log('MONTH: ', month);
    console.log('YEAR: ', year);
    console.log('isMonthAbleToQuotas(month, year): ', isMonthAbleToQuotas(month, year))
    if (isMonthAbleToQuotas(month, year)) {
        //verificando se existe CDI local
        const igpmLocal = await doGetIGPMMonth(month, year);
        console.log('igpmLocal: ', igpmLocal);
        if (igpmLocal.success) {

            return igpmLocal.body;

        } else {

            console.log("Não existe IGPM: ", month, year);

            const responseIGPM = await ComDinheiroAPI.getIGPM(startDate, endDate);
            if (responseIGPM.success) {

                doSaveIGPMMonth(responseIGPM.body, startDate);
                return responseIGPM.body;

            } else {

                console.error("FALHA AO BUSCAR CDI NA API");

            }

        }

    } else {
        return [];
    }

}

//Obtendo composição do do fundo

export async function doGetFundCompositionByCnpj(cnpj) {

    const response = await ComDinheiroAPI.getFundCompositionByCnpj(cnpj);

    if (response.success) {
        return response.body[cnpj];
    } else {
        return null;
    }
}

export async function doGetFundFullCompositionByCnpj(cnpj) {

    const response = await ComDinheiroAPI.getFundFullCompositionByCnpj(cnpj);

    if (response.success) {
        return response.body;
    } else {
        return null;
    }
}

export async function doGetRankingManagers(referenceDate) {

    //verificar se existe a informação local
    const { month, year } = getDayMonthYearByPtDate(referenceDate);
    const responseLocal = await RankingFundsManagersAPI.getData(month, year);

    console.log('responseLocal managers: ', responseLocal);

    if (responseLocal.success
        && responseLocal.body
        && responseLocal.body.rows
        && responseLocal.body.rows[0]
        && responseLocal.body.rows[0].data) {

        return JSON.parse(responseLocal.body.rows[0].data);
    }

    const response = await ComDinheiroAPI.getRankingManagers(referenceDate);

    if (response.success && response.body) {
        const saveLocalManagers = await RankingFundsManagersAPI.save(month, year, JSON.stringify(response.body));
        if (saveLocalManagers.success) {
            console.log("MANAGERS SALVOS LOCALMENTE!");
        } else {
            console.error("FALHA AO SALVAR MANAGERS LOCALMENTE!");
        }
    }

    if (response.success) {
        return response.body;
    } else {
        return null;
    }


}

export async function doGetRankingAdmins(referenceDate) {

    //verificar se existe a informação local
    const { month, year } = getDayMonthYearByPtDate(referenceDate);
    const responseLocal = await RankingFundsAdminsAPI.getData(month, year);

    console.log('responseLocal admins: ', responseLocal);

    if (responseLocal.success
        && responseLocal.body
        && responseLocal.body.rows
        && responseLocal.body.rows[0]
        && responseLocal.body.rows[0].data) {

        return JSON.parse(responseLocal.body.rows[0].data);
    }

    const response = await ComDinheiroAPI.getRankingAdmins(referenceDate);

    if (response.success && response.body) {
        const saveLocalAdmins = await RankingFundsAdminsAPI.save(month, year, JSON.stringify(response.body));
        if (saveLocalAdmins.success) {
            console.log("ADMINS SALVOS LOCALMENTE!");
        } else {
            console.error("FALHA AO SALVAR ADMINS LOCALMENTE!");
        }
    }

    if (response.success) {
        return response.body;
    } else {
        return null;
    }


}

export async function doGetRentsMes3m6m12m(cnpjs, benchmarks, referenceDate) {

    const response = await ComDinheiroAPI.getRentsMes3m6m12m(cnpjs, benchmarks, referenceDate);

    if (response.success) {
        return response.body;
    } else {
        return null;
    }

}

export async function doGetIBOVAndCDI(startDate, endDate) {

    //verificar se existe a informação local
    const { month, year } = getDayMonthYearByPtDate(endDate);
    const responseLocal = await IbovCdiAPI.getData(month, year);

    console.log('responseLocal IbovCdiAPI: ', responseLocal);

    if (responseLocal.success
        && responseLocal.body
        && responseLocal.body.rows
        && responseLocal.body.rows[0]
        && responseLocal.body.rows[0].data) {
        const jsonData = JSON.parse(responseLocal.body.rows[0].data);

        console.log("IbovCdi local: ", jsonData);
        return jsonData;
    }

    const response = await ComDinheiroAPI.getIBOVAndCDI(startDate, endDate);

    if (response.success && response.body) {
        const saveLocalIbovCdi = await IbovCdiAPI.save(month, year, JSON.stringify(response.body));
        if (saveLocalIbovCdi.success) {
            console.log("IbovCdi SALVOS LOCALMENTE!");
        } else {
            console.error("FALHA AO SALVAR IbovCdi LOCALMENTE!");
        }
    }

    if (response.success) {
        return response.body;
    } else {
        return null;
    }

}

export async function doGetIPCAdp(startDate, endDate) {

    const response = await ComDinheiroAPI.getIPCAdp(startDate, endDate);
    if (response.success) {
        return response.body
    } else {
        return null;
    }

}

export async function doGetCDI(startDate, endDate, isAcum, logCod) {

    const response = await ComDinheiroAPI.getCDI(startDate, endDate, isAcum, logCod);
    if (response.success) {
        return response.body
    } else {
        return null;
    }

}

export async function doGetIGPM(startDate, endDate) {

    const response = await ComDinheiroAPI.getIGPM(startDate, endDate);
    if (response.success) {
        return response.body
    } else {
        return null;
    }

}

export async function doSelicMeta(startDate, endDate) {

    const response = await ComDinheiroAPI.getSelicMeta(startDate, endDate);
    if (response.success) {
        return response.body
    } else {
        return null;
    }

}

export async function doGetPU_med(titles, startDate, endDate) {

    const response = await ComDinheiroAPI.getPU_med(titles, startDate, endDate);
    if (response.success) {
        return response.body
    } else {
        return null;
    }

}